(() => {
  console.info('%cここに秘密はありません', 'font-size: 20px; color: #37ABFF;')

  const episodeDates = [
    new Date('2021-01-22T16:00:00.000+03:00'),
    new Date('2021-01-29T16:00:00.000+03:00'),
    new Date('2021-02-05T18:00:00.000+03:00'),
    new Date('2021-02-12T19:00:00.000+03:00')
  ]

  function ubtoa(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  // @ts-ignore
  window.ubtoa = ubtoa

  function uatob(str) {
    return decodeURIComponent(escape(window.atob(str)));
  }

  const bloggerShown = [
    false,
    false,
    false,
    false
  ]

  const dateSet = [
    false,
    false,
    false,
    false
  ]

// TODO: вбить реальную инфу о эпизодах
  const episodesInfo = [
    {
      title: 'Серия 1: Фуд-фуд-фуд-блог',
      link: 'https://clck.ru/SuZwF'
    },
    {
      title: 'Серия 2: Убийственное амплуа',
      link: 'https://clck.ru/T2nwp'
    },
    {
      title: 'Серия 3: Robin HUD',
      link: 'https://clck.ru/T9rAk'
    },
    {
      title: 'Серия 4: Истинно качественный контент',
      link: 'https://clck.ru/TFyZJ'
    }
  ];

  const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    hour: 'numeric',
    minute: '2-digit'
  })

  const checkShow = () => {
    const today = new Date()

    for (let i in episodeDates) {
      if (today > episodeDates[i] && !bloggerShown[i]) {
        const num = parseInt(i) + 1;
        bloggerShown[i] = true

        const episode = document.querySelector(`.episode-${num}`)
        episode.querySelector('.release-date').remove()
        const button = document.createElement('a')
        button.classList.add('button')
        button.href = episodesInfo[i].link
        button.innerHTML = 'Смотреть сериал'
        episode.append(button)
      } else if (today < episodeDates[i] && !dateSet[i]) {
        const num = parseInt(i) + 1;
        const episode = document.querySelector(`.episode-${num}`)
        episode.querySelector('.release-time').innerHTML = dateFormatter.format(episodeDates[i])
        dateSet[i] = true
      }
    }

    if (today < episodeDates[3]) {
      setTimeout(checkShow, 1000)
    }
  }

  checkShow()

  document.querySelector('.current-year').innerHTML = (new Date()).getFullYear().toString()

  async function supportsWebp() {
    if (!self.createImageBitmap) return false;

    const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
    const blob = await fetch(webpData).then(r => r.blob());
    return createImageBitmap(blob).then(() => true, () => false);
  }

  (async () => {
    let className = 'webp';

    if (!await supportsWebp()) {
      className = 'no-webp'
    }

    document.querySelectorAll('.main-container > section')
      .forEach(section => section.classList.add(className))
  })();
})()
